import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.data('contactForm', () => ({
    isLoading: false,
    isSuccess: false,
    isError: false,
    
    submitForm() {
        this.isLoading = true;
        this.isSuccess = false;
        this.isError = false;

        fetch(this.$el.action, {
            method: this.$el.method,
            body: new FormData(this.$el),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            }
        })
        .then(response => {
            if (response.ok) {
                this.isSuccess = true;
                this.$el.reset(); // Formular leeren
            } else {
                this.isError = true;
            }
        })
        .catch(() => {
            this.isError = true;
        })
        .finally(() => {
            this.isLoading = false;
        });
    }
}));


Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.getElementById('hero-canvas');
    if (!canvas) return;

    const context = canvas.getContext('2d');

    // 1. Konfiguration
    const frameCount = 120; // Anzahl deiner Bilder
    // Funktion, um den Pfad zum Bild basierend auf dem Index zu generieren
    // (z. B. padStart füllt führende Nullen auf: 001, 002, ..., 120)
    const currentFrame = index => (
        `/images/nca/widrme/videoWoText/frame_${index.toString().padStart(4, '0')}.webp`
    );

    // 2. Bilder vorladen (Preloading) für flüssiges Scrubbing
    const images = [];
    let imagesLoaded = 0;
    
    // Leeres Image-Objekt für den Start
    const img = new Image();
    img.src = currentFrame(1);
    
    // Funktion zum Skalieren und Zeichnen des Bildes im Canvas
    function drawImageScaled(img, ctx) {
        // Berechne das Seitenverhältnis des aktuellen Bildes
        const imgRatio = img.width / img.height;
        // Passe die Canvas Breite an die Bildschirmbreite an
        canvas.width = window.innerWidth;
        // Berechne die dazugehörige Höhe anhand des Bild-Seitenverhältnisses
        canvas.height = window.innerWidth / imgRatio;
        
        // Bild exakt ins Canvas zeichnen
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
        
        // Passe ggf. die Höhe des sticky Containers an das Canvas an
        const stickyContainer = canvas.closest('.sticky');
        if(stickyContainer) {
            stickyContainer.style.height = canvas.height + 'px';
        }
    }

    // Wir rendern das erste Bild sofort, wenn es geladen ist
    img.onload = () => {
        drawImageScaled(img, context);
    };

    // Jetzt feuern wir das Preloading aller anderen Bilder ab
    for (let i = 1; i <= frameCount; i++) {
        const preImg = new Image();
        preImg.src = currentFrame(i);
        images.push(preImg);
    }

    // Update bei Window Resize
    window.addEventListener('resize', () => {
        // Hole aktuellen Frame Index anhand des Scroll-Fortschritts
        const section = document.getElementById('hero');
        const sectionTop = section.offsetTop;
        const maxScroll = section.scrollHeight - window.innerHeight;
        let scrollFraction = (window.scrollY - sectionTop) / maxScroll;
        scrollFraction = Math.max(0, Math.min(scrollFraction, 1));
        const frameIndex = Math.min(frameCount - 1, Math.floor(scrollFraction * frameCount));
        
        const frameToRender = images[frameIndex];
        if (frameToRender && frameToRender.complete) {
            drawImageScaled(frameToRender, context);
        }
    });

    // 3. Scroll-Logik
    // Wir nutzen RequestAnimationFrame für maximale Performance
        // Parallax Vorbereitung
    const parallaxElements = document.querySelectorAll('.js-parallax');
    // Multiplikator für subtilen, edlen Effekt (0.05 = langsam)
    const parallaxSpeed = .05; 
    
    // Allen Parallax-Elementen vorab will-change geben für GPU-Beschleunigung
    parallaxElements.forEach(el => el.style.willChange = 'transform');

    // 3. Scroll-Logik (Canvas & Parallax kombiniert)
    let scrollTimeout;

    window.addEventListener('scroll', () => {
        if (scrollTimeout) {
            window.cancelAnimationFrame(scrollTimeout);
        }

        scrollTimeout = window.requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            const windowHeight = window.innerHeight;

            // --- TEIL 1: CANVAS LOGIK ---
            const section = document.getElementById('hero');
            if (section) {
                const sectionTop = section.offsetTop;
                const maxScroll = section.scrollHeight - windowHeight;
                let scrollFraction = (scrollY - sectionTop) / maxScroll;
                
                scrollFraction = Math.max(0, Math.min(scrollFraction, 1));
                if (isNaN(scrollFraction)) scrollFraction = 0;
                
                const frameIndex = Math.min(
                    frameCount - 1,
                    Math.floor(scrollFraction * frameCount)
                );

                const frameToRender = images[frameIndex];
                if (frameToRender && frameToRender.complete) {
                    drawImageScaled(frameToRender, context);
                }
            }

            // --- TEIL 2: PARALLAX LOGIK ---
            if (parallaxElements.length > 0) {
                parallaxElements.forEach(el => {
                    // Position des Elements relativ zum Dokumentanfang
                    // (getBoundingClientRect() ändert sich beim Scrollen, daher addieren wir scrollY dazu)
                    const elementTop = el.getBoundingClientRect().top + scrollY; 
                    
                    // Berechnen wir, wie weit das Element von der Bildschirmmitte entfernt ist
                    const distanceFromCenter = (scrollY + windowHeight / 2) - elementTop;
                    
                    // Daraus ergibt sich unser subtiler Y-Offset
                    const yOffset = distanceFromCenter * parallaxSpeed;

                    // Den weichen Versatz anwenden
                    el.style.transform = `translate3d(0, ${yOffset}px, 0)`; // translate3d zwingt GPU-Rendering
                });
            }
        });
    });

    const animatedButtons = document.querySelectorAll('.js-animate-btn');
    
    if (animatedButtons.length > 0) {
        // Optionen für den Observer (Wann gilt das Element als sichtbar?)
        // threshold: 0.5 bedeutet, der Button muss zu 50% sichtbar sein, bevor die Animation startet
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 1
        };

        const buttonObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                
                    entry.target.classList.add('animate-shine');
                    
                    // Optional: Damit es bei JEDEM reinscrollen animiert, entnehmen wir das unobserve:
                    // Wenn es nur beim ERSTEN mal animieren soll, diese Zeile aktivieren:
                    // observer.unobserve(entry.target); 
                    
                    // Um den Effekt nach der Animation wieder zurückzusetzen (damit er beim nächsten 
                    // Scrollen wieder funktioniert), entfernen wir die Klasse nach 1.5s wieder.
                    setTimeout(() => {
                         entry.target.classList.remove('animate-shine');
                    }, 1500); 
                }
            });
        }, observerOptions);

        // Observer an alle Buttons hängen
        animatedButtons.forEach(btn => {
            buttonObserver.observe(btn);
        });
    }

    // --- TEIL 4: COUNT-UP ANIMATION (Intersection Observer) ---
    const countUpElements = document.querySelectorAll('.count-up');

    if (countUpElements.length > 0) {
        const countUpObserverOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        };

        const countUpObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    
                    // Only animate if it hasn't been animated yet to prevent unexpected restarts mid-scroll
                    if (el.classList.contains('is-animated')) return;
                    el.classList.add('is-animated');

                    const target = parseInt(el.getAttribute('data-target') || '0', 10);
                    const suffix = el.getAttribute('data-suffix') || '';
                    const duration = 1000; // 2 seconds animation
                    
                    let startTimestamp = null;
                    const step = (timestamp) => {
                        if (!startTimestamp) startTimestamp = timestamp;
                        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                        
                        // easeOutQuart for smooth deceleration
                        const easeOutProgress = 1 - Math.pow(1 - progress, 4);
                        const currentCount = Math.floor(easeOutProgress * target);
                        
                        el.innerText = currentCount + suffix;
                        
                        if (progress < 1) {
                            window.requestAnimationFrame(step);
                        } else {
                            el.innerText = target + suffix; // Ensure final value is exact
                        }
                    };
                    
                    window.requestAnimationFrame(step);
                    
                    // Unobserve after animation starts so it only runs once
                    observer.unobserve(el);
                }
            });
        }, countUpObserverOptions);

        countUpElements.forEach(el => {
            countUpObserver.observe(el);
        });
    }
});
